import { objectKeysDiff } from './utils';
const debugRemappedKeys = (keys, callback) => {
  const remapped = {};
  keys.forEach(x => remapped[x] = callback(x));
  return remapped;
};
export const logUserProperties = (debug, log, original, mapped) => {
  if (debug) {
    const keyDiff = objectKeysDiff(original, mapped);
    if (keyDiff.length) {
      var _log$user_properties;
      log.user_properties = ((_log$user_properties = log.user_properties) === null || _log$user_properties === void 0 ? void 0 : _log$user_properties.concat(keyDiff)) || keyDiff;
    }
  }
};
export const logEventProperties = (debug, log, original, mapped) => {
  if (debug) {
    const keyDiff = objectKeysDiff(original, mapped);
    if (keyDiff.length) {
      var _log$event_properties;
      log.event_properties = ((_log$event_properties = log.event_properties) === null || _log$event_properties === void 0 ? void 0 : _log$event_properties.concat(keyDiff)) || keyDiff;
    }
  }
};
export const writeLog = (log, title, typeCallback, propertyCallback) => {
  var _log$event_properties2, _log$user_properties2;
  if (log.event_type || (_log$event_properties2 = log.event_properties) !== null && _log$event_properties2 !== void 0 && _log$event_properties2.length || (_log$user_properties2 = log.user_properties) !== null && _log$user_properties2 !== void 0 && _log$user_properties2.length) {
    var _log$event_properties3, _log$user_properties3;
    console.groupCollapsed(title);
    if (log.event_type) {
      console.log('The event type was remapped:');
      const debugType = {};
      debugType[log.event_type] = typeCallback(log.event_type);
      console.table(debugType);
    }
    if ((_log$event_properties3 = log.event_properties) !== null && _log$event_properties3 !== void 0 && _log$event_properties3.length) {
      console.log('The following event property key(s) were remapped:');
      console.table(debugRemappedKeys(log.event_properties, propertyCallback));
    }
    if ((_log$user_properties3 = log.user_properties) !== null && _log$user_properties3 !== void 0 && _log$user_properties3.length) {
      console.log('The following user property key(s) were remapped:');
      console.table(debugRemappedKeys(log.user_properties, propertyCallback));
    }
    console.groupEnd();
  }
};
export default {};
//# sourceMappingURL=log.js.map